<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter {{ utils.getLangTerm('hazardous-substances.list.account-title', 'Hazardous Substances') }}</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="filter-content d-flex m-0 pt-4 pb-2 flex-wrap" style="justify-content: space-evenly">

  <ng-container matColumnDef="sites">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectSites()"
        [matBadge]="'' + (filters.site_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>location_on</mat-icon> {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }}
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="type">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" style="width: 150px;">
        <mat-label>Type</mat-label>
        <mat-select placeholder="Type" [(ngModel)]="filters.hazardous_substance_type" name="hazardous_substance_type" id="hazardous_substance_type">
          <mat-option value="">All</mat-option>
          <mat-option *ngFor="let hazardous_substance_type of utils.getHazardousSubstanceTypes()" [value]="hazardous_substance_type">
            {{ '(' + ((hazardous_substance_type || '').substring(0, 1)) + ') ' + hazardous_substance_type }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex flex-wrap justify-content-center my-2 py-2">

  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="onSaveAndClose()">
        <mat-icon>filter_list</mat-icon> Apply Filter
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearAndClose()">
        <mat-icon> clear_all</mat-icon> Clear Filter
      </button>
    </div>
  </ng-container>

</mat-dialog-actions>

